import React from 'react';
import propTypes from 'prop-types';
import { Upload } from 'antd';
import { Icon, Form } from '@common/components';
import { Colors, FontSize, LineHeight } from '@common/tokens';

const { Dragger } = Upload;

export function SubmittalPacketsUploadInput({
  onChange,
  availableFileNames,
  disabled,
}) {
  const uploadNewDescription = `
    Upload a PDF containing a cover sheet, résumé, and two references. Skills
    checklist and license verification are also required for some roles.
  `;

  const draggerProps = {
    name: 'file',
    accept: '.pdf',
    action: '',
    text: 'Click or drag a file to upload',
    style: {
      backgroundColor: Colors.elmHyperlight,
      fontWeight: 800,
    },
    disabled,
    onChange,
    beforeUpload() {
      return false; // Prevent defined 'action' from being triggered
    },
  };

  const formItemRules = [
    {
      required: true,
      message: 'Please attach a file',
    },
    {
      validator(rule, fileModel) {
        if (
          !fileModel?.file?.name ||
          !availableFileNames ||
          availableFileNames.length === 0 ||
          !availableFileNames.includes(fileModel.file.name)
        ) {
          return new Promise((resolve) => resolve());
        }

        return new Promise((resolve, reject) => {
          reject(new Error('Invalid file uploaded'));
        });
      },
      message: "There's already a file with the same name.",
    },
  ];

  return (
    <>
      <p className="submittal-packet-upload-description">
        {uploadNewDescription}
      </p>
      <Form.Item
        name="submittalPacket"
        valuePropName="file"
        rules={formItemRules}
      >
        <Dragger className="submittal-packet-upload" {...draggerProps}>
          <Icon
            icon="cloudUpload"
            kind="regular"
            color="elmLighter"
            size="xxl"
          />
          <p className="submittal-packet-upload-text">{draggerProps.text}</p>
        </Dragger>
      </Form.Item>
      <style jsx>{`
        .submittal-packet-upload-description {
          margin-top: 16px;
          font-size: ${FontSize.md};
          line-height: ${LineHeight.lg};
          font-weight: 400;
          color: ${Colors.midnightLighter};
        }
        .submittal-packet-upload-text {
          color: ${Colors.elm};
          margin-top: 16px;
        }
        :global(.ant-upload.ant-upload-drag .ant-upload) {
          padding: 24px;
        }
        :global(
          .submittal-packet-upload
            + .ant-upload-list
            > div:not(:last-child)
            span
        ) {
          opacity: 0.5;
          text-decoration: line-through;
        }
        :global(
          .submittal-packet-upload
            + .ant-upload-list
            .ant-upload-list-item-card-actions
        ) {
          display: none;
        }
      `}</style>
    </>
  );
}

SubmittalPacketsUploadInput.propTypes = {
  availableFileNames: propTypes.arrayOf(propTypes.string).isRequired,
  onChange: propTypes.func,
  disabled: propTypes.bool,
};

SubmittalPacketsUploadInput.defaultProps = {
  disabled: false,
};
